var React = require('react');

function SiteOptimization (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"14","fill":"#415236","key":0}),React.createElement("path",{"d":"M28.5 21.5L24.3 25.7L22.7 23.3L19.5 26.5","stroke":"#91BD75","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M26.5 21.5H28.5V23.5","stroke":"#91BD75","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M21 34H27C32 34 34 32 34 27V21C34 16 32 14 27 14H21C16 14 14 16 14 21V27C14 32 16 34 21 34Z","stroke":"#91BD75","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

SiteOptimization.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = SiteOptimization;

SiteOptimization.default = SiteOptimization;
